import { CustomTable } from '../../../../../../components/Table/CustomTable'
import { TableEmptyState } from '../../../../../../components/Table/TableStates'
import { ModeloVersaoLinha } from '../../../core/_models'
import { useVersoesModelo } from '../core/useVersoesModelo'
import { modeloPlataformaColumns } from './columns/_columns'

/** Demais versões do modelo (a publicada fica em destaque no cabeçalho). */
export const ModeloPlataformaTable = () => {
  const { demais, isLoading, isError, refetch } = useVersoesModelo()

  return (
    <CustomTable<ModeloVersaoLinha>
      id='kt_table_modelo_plataforma'
      ariaLabel='Versões do modelo de protocolo da plataforma'
      itemLabel={{ singular: 'versão', plural: 'versões' }}
      data={demais}
      columns={modeloPlataformaColumns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          title='Nenhuma outra versão do modelo.'
          description='Rascunhos e versões substituídas aparecem aqui.'
        />
      }
      notPaginated
    />
  )
}
